/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */

export type SecurityType = typeof SecurityType[keyof typeof SecurityType];


export const SecurityType = {
  common: 'common',
  preferred: 'preferred',
  reit: 'reit',
  etf: 'etf',
  adr: 'adr',
  right: 'right',
  warrants: 'warrants',
  units: 'units',
  tracking_stock: 'tracking_stock',
  closed_end_fund: 'closed_end_fund',
} as const;
